import React from 'react'
import { ajaxGet } from 'api/explus-api'
import MyUpdatesSingle from './MyUpdatesSingle'
import Loader from '../../Loader/Loader'

class MyUpdatesSingleContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      community: '',
      loading: true
    }
  }

  componentDidMount() {
    const url = `web/community/${this.props.match.params.updateId}`

    ajaxGet(url).then(data => {
      if (data.status === undefined) {
        this.setState({community: data})
      }
      this.setState({loading: false})
    })
  }

  displayView() {
    if (this.state.loading === true) {
      return <Loader/>
    } else {
      return <MyUpdatesSingle community={this.state.community}/>
    }
  }

  render() {
    return this.displayView()
  }
}

export default MyUpdatesSingleContainer
